import { createContext, useContext } from "react";
import { useCookieConsent } from "../hooks/useCookieConsent";

const CookieConsentContext = createContext(null);

export function CookieConsentProvider({ children }) {
  const consent = useCookieConsent();
  return (
    <CookieConsentContext.Provider value={consent}>
      {children}
    </CookieConsentContext.Provider>
  );
}

export function useCookieConsentContext() {
  const ctx = useContext(CookieConsentContext);
  if (!ctx) throw new Error("useCookieConsentContext must be used within CookieConsentProvider");
  return ctx;
}
